import SBEditable from "../sbEditable/sbEditable";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";
import StoryblokLink from "../link/StoryblokLink";
import {SVGIconKeyToComponent} from "../../helpers/datasourceHelpers";
import {Button} from "@crunchyroll/cx-web-components";
import {FormattedMessage} from "react-intl";

import styles from "./seasonalSeriesCard.module.scss";

function SeasonalSeriesCard({blok, isNewSeasonPicks}) {
  const keyArt = blok && blok.key_art_image;
  const seriesUrl = blok && blok.series_url;
  const hasSeriesUrl = seriesUrl && seriesUrl.url;

  const socialMediaLinks = [
    {
      key: "youtube",
      linkObj: blok.youtube,
    },
    {
      key: "facebook",
      linkObj: blok.facebook,
    },
    {
      key: "twitter",
      linkObj: blok.twitter,
    },
    {
      key: "instagram",
      linkObj: blok.instagram,
    },
  ];

  const airtimes = [
    {
      key: "sub",
      label: blok.sub_airtime_label,
      dateTime: blok.sub_airtime_value,
    },
    {
      key: "dub",
      label: blok.dub_airtime_label,
      dateTime: blok.dub_airtime_value,
    },
  ];

  return (
    <SBEditable blok={blok} key={blok._uid}>
      <div
        className={
          isNewSeasonPicks
            ? `${styles.seasonPicksCard}`
            : `${styles.seasonalCard}`
        }
      >
        {keyArt && keyArt.filename && (
          <div className={styles.imageContainer}>
            <StoryblokImageBasic image={keyArt} width={172} height={255} />
          </div>
        )}
        <div
          className={
            isNewSeasonPicks
              ? `${styles.cardContent}`
              : `${styles.verticalCardContent}`
          }
        >
          <div>
            <div
              className={
                isNewSeasonPicks
                  ? `${styles.cardTitleDiv}`
                  : `${styles.verticalTitleDiv}`
              }
            >
              <h5>{blok.series_title}</h5>
              <p className={styles.studio}>{blok.studio}</p>
            </div>
            {airtimes.map((airtime, i) => {
              const key = airtime.key;
              const label = airtime.label;
              const dateTime = airtime.dateTime;
              return (
                label &&
                dateTime && (
                  <p className={styles.airtime} key={`${key}, ${i}`}>
                    <span className={styles.airtimeLabel}>{label}</span>{" "}
                    <span className={styles.airtimeValue}>{dateTime}</span>
                  </p>
                )
              );
            })}
            <p className={styles.seriesDescription}>
              {blok.series_description}
            </p>
            <p className={styles.availability}>
              <span>{blok.availability}</span>
            </p>
          </div>
          <div
            className={
              !isNewSeasonPicks
                ? `${styles.verticalBtnGroup}`
                : `${styles.cardBtnGroup}`
            }
          >
            <Button
              className={
                hasSeriesUrl ? `${styles.cardCta}` : `${styles.disabledCardCta}`
              }
              type="one"
              as="a"
              href={hasSeriesUrl && seriesUrl.url}
              isWide
              isDisabled={hasSeriesUrl ? false : true}
            >
              <FormattedMessage
                id={
                  hasSeriesUrl
                    ? "watching_status.watch_now"
                    : "blocked_stream.coming_soon_title"
                }
              />
            </Button>
            <div className={styles.socialMedia}>
              {socialMediaLinks.map(item => {
                const platform = item.key;
                const linkObj = item.linkObj;
                const linkUrl = item.linkObj.url;
                return (
                  linkUrl && (
                    <div className={styles.socialIconWrapper} key={platform}>
                      <StoryblokLink
                        linkObject={linkObj}
                        className={styles.socialIcon}
                      >
                        {SVGIconKeyToComponent(`${platform}`)}
                      </StoryblokLink>
                    </div>
                  )
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </SBEditable>
  );
}

export default SeasonalSeriesCard;
